import Image from 'next/image';
import { meziaTheme } from '@/config/brand';

type Props = {
  src: string;
  size?: number;
  className?: string;
};

export function BrandIcon({ src, size = 20, className }: Props) {
  if (meziaTheme) {
    return (
      <span
        aria-hidden
        style={{
          width: size,
          height: size,
          maskImage: `url("${src}")`,
          WebkitMaskImage: `url("${src}")`,
          maskMode: 'alpha',
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskPosition: 'center',
        }}
        className={`inline-block shrink-0 bg-primary-green-day ${className ?? ''}`}
      />
    );
  }

  return <Image src={src} width={size} height={size} alt='' className={className} />;
}
